export default __webpack_public_path__ + "static/media/email-verified.3a1045cb.svg";